import { render, staticRenderFns } from "./car-infor.vue?vue&type=template&id=1f1dfb36&scoped=true&"
import script from "./car-infor.vue?vue&type=script&lang=js&"
export * from "./car-infor.vue?vue&type=script&lang=js&"
import style0 from "./car-infor.vue?vue&type=style&index=0&id=1f1dfb36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1dfb36",
  null
  
)

export default component.exports